export const CandlestickChartIcon = () => {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 5v4"></path>
      <rect width="4" height="6" x="7" y="9" rx="1"></rect>
      <path d="M9 15v2"></path>
      <path d="M17 3v2"></path>
      <rect width="4" height="8" x="15" y="5" rx="1"></rect>
      <path d="M17 13v3"></path>
      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
    </svg>
  );
};
